import { Button, Card, Form } from '@ui/themed';
import { t } from 'i18next';
import { useFormProps } from '../../../hooks/use-forms-props';
import { useCustomerGroupsQuickSetupForm } from '../hooks/use-customer-groups-quick-setup-form';
import { AssignedPriceListField } from './quick-setup/assigned-price-list-field';
import { MinOrderRequirementsField } from './quick-setup/min-order-requirements-field';
import { NameField } from './quick-setup/name-field';
import { PaymentMethodsField } from './quick-setup/payment-methods-field';
import { SwitchToAdvancedAlert } from './quick-setup/switch-to-advanced-alert';

export function CustomerGroupsQuickSetup({ onCancel }: { onCancel: () => Promise<void> | void }) {
  const form = useCustomerGroupsQuickSetupForm();
  const formProps = useFormProps(form);

  return (
    <Form {...formProps}>
      <Card>
        <Card.Header headingLevel="h2">
          {t('features:customer_group.components.quick_setup.card.title')}
        </Card.Header>

        <Card.Body>
          <NameField />
          <AssignedPriceListField />
          <PaymentMethodsField />
          <MinOrderRequirementsField />
        </Card.Body>
      </Card>

      <SwitchToAdvancedAlert />

      <span className="flex justify-end gap-2">
        <Button variant="secondary" onClick={onCancel} disabled={formProps.loading}>
          {t('buttons:cancel')}
        </Button>
        <Button type="submit" loading={formProps.loading} disabled={!formProps.isDirty}>
          {t('features:customer_group.components.quick_setup.actions.submit')}
        </Button>
      </span>
    </Form>
  );
}
